'use client';

import { Box, SystemIcon, Typography } from '@wishket/design-system';

import { FadeUpContainer, Illust } from '@/shared/Components';

interface AskAILoadingCardProps {
  title: string;
  remainingTime: number;
}

const AskAILoadingCard = ({ title, remainingTime }: AskAILoadingCardProps) => {
  return (
    <FadeUpContainer>
      <Box className="flex flex-col gap-7 desktop:gap-4">
        <Box className="flex size-8 shrink-0 items-center justify-center rounded-full bg-gradient-primary-0 desktop:size-10">
          <SystemIcon
            name="medium_answer"
            className="text-w-white desktop:hidden"
          />
          <SystemIcon
            name="large_answer"
            className="hidden text-w-white desktop:block"
          />
        </Box>
        <Box className="flex flex-col items-center gap-12">
          <Box className="flex flex-col items-center gap-1.5">
            <Typography
              variant="subTitle2"
              className="desktop:subTitle1 whitespace-pre-line text-center font-medium text-w-gray-900 desktop:whitespace-normal"
            >
              {title}
            </Typography>
            <Typography variant="body1" className="text-w-gray-400">
              남은 시간 최대 {remainingTime}초
            </Typography>
          </Box>
          <Illust name="yogo_cat_loading" />
        </Box>
      </Box>
    </FadeUpContainer>
  );
};

export default AskAILoadingCard;
